import { Languages } from "waapi/front-utils/hooks/useTranslation/types.js";
import sendMessage from "../../../utils/chromeMessages.js";

export async function setLanguage(
    extensionId: string,
    params: {
        language: Languages;
    },
): Promise<boolean> {
    try {
        const result = await sendMessage<boolean>({
            extensionId,
            message: {
                action: "GLOBAL/SET_USER_LANGUAGE",
                ...params,
            },
        });

        return result;
    } catch (err) {
        return false;
        // @INFO: we catch the error prevent spamming Sentry
    }
}
